import React from "react";
import { Link } from "./link";
import { getOrgConfig } from "../utils/orgUtils";
import { useAppContext } from "../contexts/appContext";

export const SupportInfo = () => {
  const { meetingOrgId } = useAppContext();
  const { supportEmail, supportPhone } = getOrgConfig(meetingOrgId);
  if (!supportEmail && !supportPhone) return null;
  return (
    <>
      If you experience any technical issues,
      {supportPhone && (
        <>
          please contact our Student Help Desk line at{" "}
          <Link
            href={`tel:+1${supportPhone.replace(/\D/g, "")}`}
            text={` ${supportPhone} `}
          />
        </>
      )}
      {supportPhone && supportEmail && " or "}
      {supportEmail && (
        <>
          please email{" "}
          <Link href={`mailto:${supportEmail}`} text={` ${supportEmail}`} />
        </>
      )}
      {"."}
    </>
  );
};
